import React from 'react';
import { useIntl } from 'react-intl';

import { ButtonClose, MODAL_ARIA_LABELLEDBY } from '@/shared/services/modal';

import { Description, Title, Wrapper } from './parts';

interface IProps {
  close: () => void;
}
const Header: React.FC<IProps> = ({ close }) => {
  const { formatMessage } = useIntl();

  const messages = {
    headerTitle: formatMessage({ id: 'Title' }),
    headerSubTitle: formatMessage({ id: 'SubTitle' }),
  };

  const isTitle = !!messages.headerTitle.trim();
  const isSubTitle = !!messages.headerSubTitle.trim();

  const title = isTitle ? messages.headerTitle : messages.headerSubTitle;

  return (
    <Wrapper className="Header" id={MODAL_ARIA_LABELLEDBY}>
      <ButtonClose handlerClose={close} style={{ color: '#ffffff' }} />
      <Title
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      {isTitle && isSubTitle && (
        <Description
          dangerouslySetInnerHTML={{
            __html: messages.headerSubTitle,
          }}
        />
      )}
    </Wrapper>
  );
};

export default Header;
